import { Map as ImmutableMap, Record, type RecordOf } from 'immutable';
import type { CashFlowTransaction, SplitItemProps } from 'companion-app-components/flux/transactions/transactionsTypes';

// ================================================================================================
// Payee List Store
// ================================================================================================

export type PayeeListProps = {
  payeesByAccountId: ImmutableMap<string, ImmutableMap<string, Payee>>;
  isLoading: boolean;
  loadPending?: boolean;
};
export type PayeeList = RecordOf<PayeeListProps>;

export const mkPayeeListStore = Record<PayeeListProps>({
  payeesByAccountId: ImmutableMap(),
  isLoading: false,
  loadPending: false,
});

export type PayeeProps = {
  id: string | null;
  name: string | null;
  amountString: string | null;
  catString: string | null;
  tagString: string | null;
  txn: CashFlowTransaction | null;
  count: number;
};

export type Payee = RecordOf<PayeeProps>;
export const mkPayee = Record<PayeeProps>({
  id: null,
  name: null,
  amountString: null,
  catString: null,
  tagString: null,
  txn: null,
  count: 0,
});

export type SplitItemType = SplitItemProps;
